interface ScrollToTopOptions extends ScrollToOptions {
    enabled?: boolean;
    top?: number;
}

export function useScrollToTop({
    enabled = true,
    top = 22,
    ...scrollOptions
}: ScrollToTopOptions = {}) {
    const scrollToTop = () => {
        if (enabled) {
            window.scrollTo({ top, behavior: "smooth", ...scrollOptions });
        }
    };

    return scrollToTop;
}
